import { withTranslation } from "next-i18next";
import { useRouter } from "next/compat/router";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { usePrice } from "@hooks/use-prices";
import Link from "@components/core/Link";
import IconSvg from "@components/core/IconSvg";
import catalogContexts from "@utils/constants/catalogContexts";
import ProductTitle from "./ProductTitle";
import ProductAction from "../ProductAction";
import ProductSharedPictures from "./ProductSharedPictures/ProductSharedPictures";
import ProductDetails from "./ProductDetails";

function ProductInformations({ product, context, openCompleteReviews, t }) {
  const router = useRouter();
  const price = usePrice();

  function sendToggleContextEvent() {
    const defaultEventData = {
      tracking_name: context === catalogContexts.sales ? "productPageSwitchToRent" : "productPageSwitchToBuy",
      page: router.asPath,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  return (
    <div className="product-informations">
      <div className="product-informations-container">
        <div className="product-informations-content">
          <section className="pb-4 mb-2 mb-lg-0 pb-lg-5">
            <ProductTitle
              product={product}
              context={context}
              openCompleteReviews={openCompleteReviews}
            />

            <ProductAction
              product={product}
              context={context}
            />
          </section>

          <ProductSharedPictures
            product={product}
          />

          <ProductDetails product={product} />

          <section className="text-primary d-flex align-items-center">
            <div className="toggle-context-link-icon">
              {context === catalogContexts.sales ? (
                <IconSvg name="drawer_icon" className="w-100" key="drawer"/>
              ) : (
                <IconSvg name="cart" className="w-100" key="cart" />
              )}
            </div>
            <Link
              variant="primary"
              href={`/products/${router.query.slug}${context === catalogContexts.sales ? "" : "?context=sales"}`}
              onClick={sendToggleContextEvent}
            >
              {context === catalogContexts.sales ? t("product:go_to_swap_version") : t("product:go_to_sales_version", { price: price(product.current_price) })}
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
}

export default withTranslation("product")(ProductInformations);